import React, { useEffect, useState } from 'react';
import close_btn from '../../assets/close.svg';
import '../../css/shillaDetail.css';
import checkImg from '../../assets/check.png';
import shareImg from '../../assets/share.png';
import aboutIcon from '../../assets/aboutIcon.png';
import toggleIcon from '../../assets/toggleIcon.png';
import nftAboutIcon from '../../assets/nftAboutMenu.png';
import cardImg from '../../assets/hyatt_vip_card.png';
import { useRecoilValue } from 'recoil';
import { translatedText } from '../../recoil-states/language-state';
import { motion } from 'framer-motion';

const HyattVipDetail = ({ itemData, setOpenCardModal, view = true }) => {
	const [openAbout, setOpenAbout] = useState(true);
	const [openDes, setOpenDes] = useState(true);
	const [desText, setDesText] = useState(null);
	const [subText, setSubText] = useState(null);
	const textData = useRecoilValue(translatedText);

	const tier1Content = [
		'식음료 할인 20%',
		'연 1회 파크하야트, 오크밸리 1박2일 숙박권',
	];

	const tier2Content = [
		'호텔전지점 온라인 최저가 대비 15%할인(커넥트 부킹 전화예약)',
	];

	useEffect(() => {
		document.body.style.overflow = 'hidden';

		if (itemData.image === 'lotte-card') {
			setDesText(textData.pakageCard.lotte);
			setSubText(textData.tier.lotte);
		} else if (itemData.image === 'hyatt-card') {
			setDesText(textData.pakageCard.hyatt);
			setSubText(textData.tier.hyatt);
		} else if (itemData.image === 'TS-card') {
			setDesText(textData.pakageCard.ts);
			setSubText(textData.tier.ts);
		} else if (itemData.image === 'mammoth-card') {
			setDesText(textData.pakageCard.mammoth);
			setSubText(textData.tier.mommoth);
		} else if (itemData.image === 'vluv-card') {
			setDesText(textData.pakageCard.vluv); 
			setSubText(textData.tier.vluv);
		}
		
		return () => {
			document.body.style.overflow = 'unset';
		};
		
	}, []);

	const onCloseModal = e => {
		if (e.target.id === 'membership_gallery_modal') {
			setOpenCardModal(false);
		}
	};

	return (
		<div
			className='shilla_detail'
			onClick={onCloseModal}
			id='membership_gallery_modal'
		>
			<motion.div
				className='shilla_detail_container'
				initial={{
					opacity: 0,
					scale: 0.75,
				}}
				animate={{
					opacity: 1,
					scale: 1,
					transition: {
						ease: 'easeOut',
						duration: 0.15,
					},
				}}
				exit={{
					opacity: 0,
					scale: 0.75,
					transition: {
						ease: 'easeIn',
						duration: 0.15,
					},
				}}
			>
				<div className='nft_box_container'>
					<div
						className='close_btn_svg'
						style={{ cursor: 'pointer' }}
					>
						<img
							src={close_btn}
							onClick={() => setOpenCardModal(false)}
						/>
					</div>
					<div className='hyatt_card_img'>
						<div className='hyatt_card_background'>
							<img
								src={require(`../../assets/${itemData.type}/${itemData.image}.png`)}
								style={{ width: '100%', borderRadius: '10px' }}
							/>
						</div>
					</div>
					<div className='konnect_text'>
						<h3>
							Konnect World
							<img src={checkImg} />
						</h3>
						<p>
							Owned by <span>Konnect</span>
							<img src={shareImg} />
						</p>
					</div>
					<div className='nft_detail_text_box'>
						<div className='text_box_left'>
							<h1>Konnect</h1>
							<h1>{itemData.main_text}</h1>
						</div>
						<div className='text_box_right'>
							<p>#001</p>
						</div>
					</div>
					<div className='nft_about_box'>
						<div
							className='nft_about_top'
							style={{ borderRadius: !openAbout ? '10px' : null }}
							onClick={() => setOpenAbout(!openAbout)}
						>
							<div className='nft_about_box_left'>
								<img src={aboutIcon} />
								<h1>{itemData.sub_text}</h1>
							</div>
							<div className='nft_about_box_right'>
								<img
									src={toggleIcon}
									style={{
										transform: openAbout
											? 'rotate(0deg)'
											: 'rotate(180deg)',
									}}
								/>
							</div>
						</div>
						<div
							className='nft_about_content'
							aria-expanded={!openAbout}
						>
							<p>{desText}</p>
						</div>
					</div>
					<div className='nft_about_box'>
						<div
							className='nft_about_top'
							style={{ borderRadius: !openDes ? '10px' : null }}
							onClick={() => setOpenDes(!openDes)}
						>
							<div className='nft_about_box_left'>
								<img src={nftAboutIcon} />
								<h1>Description</h1>
							</div>
							<div className='nft_about_box_right'>
								<img
									src={toggleIcon}
									style={{
										transform: openDes
											? 'rotate(0deg)'
											: 'rotate(180deg)',
									}}
								/>
							</div>
						</div>
						<div
							className='nft_about_content_bottom'
							aria-expanded={!openDes}
						>
							<p>KONNECT Utility NFT</p>
							<h1>Benefit Information</h1>
							<div className='shilla_tier'>
								<div className='tier_one_top'>
									<h1>Tier1</h1>
								</div>
								<ul>
									{subText != null &&
										subText.tier1.map(it => {
											return <li key={it}>◆ {it}</li>;
										})}
								</ul>
								<div className='shlla_tier_two'>
									<div className='tier_two_top'>
										<h1>Tier2</h1>
									</div>
									<ul>
										{subText != null &&
											subText.tier2.map(it => {
												return (
													<li
														style={{
															color: '#BBBBBB',
														}}
														key={it}
													>
														◆ {it}
													</li>
												);
											})}
									</ul>
								</div>
							</div>
						</div>
					</div>
					{view ? (
						<div className='detail_modal_btn_container'>
							<div className='detail_modal_btn_top'>
								<button className='clasic_button'>
									멤버쉽 정보 보기
								</button>
								<button className='clasic_button'>
									My Wallet으로 이동
								</button>
							</div>
							<div className='detail_modal_btn_bottom'>
								<button className='activity_button_full'>
									예약하기
								</button>
							</div>
						</div>
					) : null}
				</div>
			</motion.div>
		</div>
	);
};

export default HyattVipDetail;
